import { useState } from 'react'
import { TOURNAMENTS_TAB } from '@constants/tournamentConstants'
import { useTournamentNavigation } from '@hooks/tournaments/useTournamentNavigation'
import TournamentsListTab from './TournamentsListTab'

const TABS = Object.values(TOURNAMENTS_TAB)

// Root of the TOURNAMENTS screen: a 2-tab segmented control (Current/History),
// cloned from FreebetsMenu's pattern. `initialTab` is read back from the
// sidebar stack entry's params so the tab survives a drill-down + back.
const TournamentsMenu = ({ initialTab }) => {
  const { onSelectTournamentsTab } = useTournamentNavigation()
  const [currentTab, setCurrentTab] = useState(initialTab ?? TABS[0].KEY)
  const [slideDirection, setSlideDirection] = useState(1)

  const activeIndex = TABS.findIndex((tab) => tab.KEY === currentTab)
  const activeTab = TOURNAMENTS_TAB[currentTab] ?? TABS[0]

  const handleTabChange = (nextKey) => {
    if (nextKey === currentTab) return
    const nextIndex = TABS.findIndex((tab) => tab.KEY === nextKey)
    setSlideDirection(nextIndex >= activeIndex ? 1 : -1)
    setCurrentTab(nextKey)
    onSelectTournamentsTab(nextKey)
  }

  return (
    <div className="standard-normal-tournaments-menu-outer-container">
      <div
        className="standard-normal-tournaments-menu-tabs-container"
        style={{
          '--tournaments-tab-count': TABS.length,
          '--tournaments-tab-index': activeIndex,
        }}
      >
        {TABS.map((tab) => (
          <div
            key={tab.KEY}
            className={`standard-normal-tournaments-menu-tab ${tab.KEY === currentTab ? 'standard-normal-tournaments-menu-active-tab' : ''}`}
            onClick={() => handleTabChange(tab.KEY)}
          >
            {tab.LABEL}
          </div>
        ))}
        <span className="standard-normal-tournaments-menu-tab-indicator" aria-hidden="true" />
      </div>

      <div className="standard-normal-tournaments-menu-content-container">
        <div
          key={currentTab}
          className="standard-normal-tournaments-menu-content"
          style={{ '--tournaments-slide-direction': slideDirection }}
        >
          <TournamentsListTab origin={activeTab.ORIGIN} />
        </div>
      </div>
    </div>
  )
}

export default TournamentsMenu
